import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div data-testid="auth-loading" className="min-h-screen flex items-center justify-center text-[#5c6b64]">
        Cargando...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && roles.length && !roles.includes(user.role)) {
    return (
      <div data-testid="forbidden" className="min-h-screen flex items-center justify-center text-[#a44a4a]">
        No tiene permisos para esta sección.
      </div>
    );
  }
  return children;
}
